import type { ReactNode } from 'react';

/**
 * O marcador que um texto traduzido leva no lugar do valor em negrito: `t('chave', { email: MARK })`,
 * e `emphasize` troca o marcador pelo valor.
 */
export const MARK = '\u0000';

/** O texto traduzido com `value` em negrito no lugar do marcador. */
export function emphasize(text: string, value: string): ReactNode {
  const [before, after] = text.split(MARK);
  return (
    <>
      {before}
      <strong>{value}</strong>
      {after}
    </>
  );
}
